import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import ArticleTagTable from '@accounting/components/tables/article-tag-table/article-tag-table.vue';

@Component({
  name: 'bpc-article-tags',
  components: {
    'bpc-article-tag-table': ArticleTagTable,
  },
})
export default class ArticleTags extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
